import {BUS_NAVIGATION_CHANGED} from "../@const";

const debug = "navigation_unpin()"

export default async function navigation_unpin(navigationSectionId:string) {


    gd.layout.toggleHideMenuForCurrentApp(false)
    gd.navigationStructure.initSections()

    const section = gd.navigationStructure.get(navigationSectionId)
    debug && console.log(debug, "go to section", section)
    await gd.layout.navigation.setCurrentSection(section)

    // await gd.layout.navigation.reRender()
    await gd.layout.currentMenu?.reRender()

    gd.bus.triggerEvent(BUS_NAVIGATION_CHANGED)
}
